( function initScholarshipHoldersListFilters() {

	const filtersScrollHash = '#scholarship-holders-list-filters';
	const paginationVisitStorageKey = 'wombat_sh_list_seen_pagination';

	const root = document.querySelector( '.js-scholarship-holders-filters' );
	if ( ! root ) {

		return;

	}

	const dropdowns = Array.from( root.querySelectorAll( '.c-dropdown' ) );
	if ( dropdowns.length === 0 ) {

		return;

	}

	/**
	 * @return {void}
	 */
	const scrollFiltersIntoView = () => {

		const target = document.getElementById( 'scholarship-holders-list-filters' );
		if ( ! target ) {

			return;

		}
		const headerOverlapPx = 90;
		requestAnimationFrame( () => {

			const top = Math.max(
				0,
				target.getBoundingClientRect().top + window.scrollY - headerOverlapPx
			);
			window.scrollTo( { top, behavior: 'smooth' } );

		} );

	};

	/**
	 * @return {boolean}
	 */
	const hasActiveFilterParams = () => {

		const params = new URLSearchParams( window.location.search );
		return dropdowns.some( ( dropdown ) => {

			const key = dropdown.dataset.name || '';
			if ( ! key ) {

				return false;

			}
			const value = params.get( key );
			return value !== null && value !== '';

		} );

	};

	/**
	 * @return {boolean}
	 */
	const isListingPagedBeyondFirst = () => {

		const params = new URLSearchParams( window.location.search );
		const paged = parseInt( String( params.get( 'paged' ) || '0' ), 10 );
		const page = parseInt( String( params.get( 'page' ) || '0' ), 10 );
		if ( ( Number.isFinite( paged ) && paged > 1 ) || ( Number.isFinite( page ) && page > 1 ) ) {

			return true;

		}
		const path = window.location.pathname || '';
		const match = path.match( /\/page\/(\d+)\/?$/i );
		if ( match && match[ 1 ] ) {

			const n = parseInt( match[ 1 ], 10 );
			return Number.isFinite( n ) && n > 1;

		}

		return false;

	};

	/**
	 * @return {boolean}
	 */
	const isExplicitListingPaginationFirstPage = () => {

		const params = new URLSearchParams( window.location.search );
		if ( params.get( 'paged' ) === '1' || params.get( 'page' ) === '1' ) {

			return true;

		}
		const path = window.location.pathname || '';

		return /\/page\/1\/?$/i.test( path );

	};

	/**
	 * @return {boolean}
	 */
	const shouldScrollAfterPaginationReturnToFirst = () => {

		if ( isListingPagedBeyondFirst() ) {

			return false;

		}
		try {

			if ( sessionStorage.getItem( paginationVisitStorageKey ) === '1' ) {

				sessionStorage.removeItem( paginationVisitStorageKey );
				return true;

			}

		} catch {

			return false;

		}

		return false;

	};

	/**
	 * @return {void}
	 */
	const markPaginationBeyondFirstVisited = () => {

		if ( ! isListingPagedBeyondFirst() ) {

			return;

		}
		try {

			sessionStorage.setItem( paginationVisitStorageKey, '1' );

		} catch {



		}

	};

	let outsideClickListener = null;

	/**
	 * @return {string}
	 */
	const getFiltersBaseLink = () => {

		const raw = root.dataset.firstPageUrl || '';
		try {

			const u = raw ? new URL( raw, window.location.origin ) : new URL( window.location.href );
			u.search = '';
			u.hash = '';
			const path = u.pathname.replace( /\/page\/[0-9]+\/?$/i, '/' );
			return `${u.origin}${path}`;

		} catch {

			const u = new URL( window.location.href );
			u.search = '';
			u.hash = '';
			const path = u.pathname.replace( /\/page\/[0-9]+\/?$/i, '/' );
			return `${u.origin}${path}`;

		}

	};

	/**
	 * @param {HTMLElement} dropdown
	 * @param {string|null} dropdownName
	 * @param {boolean} isSelected
	 * @return {void}
	 */
	const setFilters = ( dropdown, dropdownName, isSelected ) => {

		const searchParams = new URLSearchParams( window.location.search );
		searchParams.delete( 'paged' );
		searchParams.delete( 'page' );
		const filterName = dropdown.dataset.name || '';
		if ( ! filterName ) {

			return;

		}
		if ( dropdownName && ! isSelected ) {

			searchParams.set( filterName, dropdownName );

		} else {

			searchParams.delete( filterName );

		}
		const paramsString = searchParams.toString();
		const baseLink = getFiltersBaseLink();
		const next = paramsString ? `${baseLink}?${paramsString}${filtersScrollHash}` : `${baseLink}${filtersScrollHash}`;
		window.location.assign( next );

	};

	/**
	 * @param {HTMLElement|null} currentDropdown
	 * @return {void}
	 */
	const closeDropdowns = ( currentDropdown = null ) => {

		dropdowns.forEach( ( dropdown ) => {

			if ( currentDropdown && currentDropdown.dataset.name === dropdown.dataset.name ) {

				return;

			}
			dropdown.classList.remove( 'c-dropdown--active' );
			dropdown.classList.remove( 'is-active' );
			dropdown.querySelector( '.c-dropdown__button' )?.setAttribute( 'aria-expanded', 'false' );

		} );

	};

	/**
	 * @param {MouseEvent} event
	 * @return {void}
	 */
	const handleOutsideClick = ( event ) => {

		if ( event.target.classList.contains( 'c-dropdown' ) || event.target.closest( '.c-dropdown' ) ) {

			return;

		}
		closeDropdowns();
		if ( outsideClickListener ) {

			document.body.removeEventListener( 'click', outsideClickListener );
			outsideClickListener = null;

		}

	};

	/**
	 * @return {void}
	 */
	const addOutsideClickListener = () => {

		if ( outsideClickListener ) {

			return;

		}
		outsideClickListener = handleOutsideClick;
		document.body.addEventListener( 'click', outsideClickListener );

	};

	/**
	 * @return {void}
	 */
	const removeOutsideClickListener = () => {

		if ( ! outsideClickListener ) {

			return;

		}
		document.body.removeEventListener( 'click', outsideClickListener );
		outsideClickListener = null;

	};

	dropdowns.forEach( ( dropdown ) => {

		const button = dropdown.querySelector( '.c-dropdown__button' );
		const buttonText = button?.querySelector( '.c-dropdown__button-text' );
		const menu = dropdown.querySelector( '.c-dropdown__menu' );
		const options = menu ? Array.from( menu.querySelectorAll( '.dropdown-option' ) ) : [];
		if ( ! button || ! buttonText || ! menu || options.length === 0 ) {

			return;

		}

		/**
		 * @return {void}
		 */
		const toggleDropdown = () => {

			dropdown.classList.toggle( 'c-dropdown--active' );
			dropdown.classList.toggle( 'is-active' );
			if ( dropdown.classList.contains( 'c-dropdown--active' ) ) {

				closeDropdowns( dropdown );
				button.setAttribute( 'aria-expanded', 'true' );
				addOutsideClickListener();

			} else {

				button.setAttribute( 'aria-expanded', 'false' );
				removeOutsideClickListener();

			}

		};

		/**
		 * @param {Event} event
		 * @return {void}
		 */
		const setDropdownValue = ( event ) => {

			const target = event.target.closest( '.dropdown-option' );
			if ( ! target ) {

				return;

			}
			const dropdownName = target.dataset.name;
			const isSelected = target.classList.contains( 'is-selected' );
			buttonText.textContent = target.textContent;
			button.setAttribute( 'data-name', dropdownName ?? '' );
			button.setAttribute( 'aria-expanded', 'false' );
			dropdown.classList.remove( 'c-dropdown--active' );
			dropdown.classList.remove( 'is-active' );
			setFilters( dropdown, dropdownName, isSelected );

		};

		button.addEventListener( 'click', toggleDropdown );
		button.addEventListener( 'keydown', ( event ) => {

			if ( event.key !== 'Enter' && event.key !== ' ' ) {

				return;

			}
			event.preventDefault();
			toggleDropdown();

		} );
		menu.addEventListener( 'click', setDropdownValue );
		menu.addEventListener( 'keydown', ( event ) => {

			if ( event.key !== 'Enter' ) {

				return;

			}
			setDropdownValue( event );

		} );

	} );

	const clearButton = root.querySelector( '.js-clear-filters-button' );
	if ( clearButton ) {

		clearButton.addEventListener( 'click', ( event ) => {

			event.preventDefault();
			window.location.assign( `${getFiltersBaseLink()}${filtersScrollHash}` );

		} );

	}

	const scrollFromPaginationReturn = shouldScrollAfterPaginationReturnToFirst();
	markPaginationBeyondFirstVisited();

	if (
		window.location.hash === filtersScrollHash ||
		hasActiveFilterParams() ||
		isListingPagedBeyondFirst() ||
		isExplicitListingPaginationFirstPage() ||
		scrollFromPaginationReturn
	) {

		scrollFiltersIntoView();

	}

} )();
